import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Customer } from 'anchor-shared/lib/model/entity/customer';
import { Router } from '@angular/router/';
import { StripePaymentDAO } from '../../../../core/services/dao/stripePaymentDAO';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs/Rx';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { User } from 'anchor-shared/lib/model/entity/user';

@Component({
  selector: 'app-customer-payment-method-status',
  templateUrl: './customer-payment-method-status.component.html',
  styleUrls: ['./customer-payment-method-status.component.scss'],
})
export class CustomerPaymentMethodStatusComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  @Input()
  customer: Customer;

  @Input()
  userId: number;

  user: User;
  last4: string;
  subs: Subscription[] = [];

  constructor(
    private router: Router,
    private stripePaymentDao: StripePaymentDAO,
    private userDAO: UserDAO,
  ) {}

  ngOnInit() {
    const userSub = this.userDAO.getById(this.userId).subscribe((user) => {
      this.user = user;
      if (this.customer && this.customer.paymentMethod) {
        if (this.customer?.paymentMethod) {
          this.last4 = this.customer.paymentMethod.last4;
        }
      } else if (user && user.stripeCustomerId) {
        const paymentMethodsSub = this.stripePaymentDao
          .adminListCustomerPaymentMethods(this.userId)
          .subscribe((paymentMethods) => {
            if (paymentMethods) {
              if (paymentMethods.data[0]) {
                let paymentMethod = paymentMethods.data[0];
                this.last4 =
                  paymentMethod.type === 'card'
                    ? paymentMethods.data[0].card.last4
                    : paymentMethods.data[0].us_bank_account.last4;
              }
            }
          });
        this.subs.push(paymentMethodsSub);
      }
    });
    this.subs.push(userSub);
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  navToUser(): void {
    if (this.userId) {
      this.router.navigate(['manage/admin/user/edit/' + this.userId]);
    }
  }
}
